var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attr"},[_c('span',{staticClass:"attr-label"},[_vm._v(_vm._s(_vm.value.label))]),_c('div',{staticClass:"attr-value",domProps:{"innerHTML":_vm._s(_vm.value.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }